module.exports = __webpack_public_path__ + "static/media/image-17-full.5e9d3179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-17-full.jpg
// module id = 360
// module chunks = 0